import {
  MotifAvatar,
  MotifHeader,
  MotifIcon,
  MotifTooltip,
} from "@ey-xd/motif-react";
import eyLogo from "../../assets/images/ey-logo-white.svg";
import "./CTHeader.scss";
import Button from "../Button/Button";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { IconoirLogOut } from "@ey-xd/motif-icon";
import { getUserLogout } from "../../store/slices/UserLogoutSlice";
import { removeOpportunityCodeFromLocal } from "../../utils/common";
import MaintenanceWindow from "../MaintenanceWindow";

const CTHeader: React.FC = () => {
  const name: string = useSelector(
    (state: RootState) => state.UserProfileSlice.name,
  );
  const avatar: string = useSelector(
    (state: RootState) => state.UserProfileSlice.avatar,
  );

  const emailId: string = useSelector(
    (state: RootState) => state.UserProfileSlice.emailId,
  );

  const userPermissions: string[] = useSelector(
    (state: RootState) => state.UserProfileSlice.userPermissions,
  );
  const dispatch = useDispatch();

  const handleLogout = async () => {
    const cleanUrl = window.location.origin + "/";
    window.history.replaceState({}, document.title, cleanUrl);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    dispatch(getUserLogout());
    removeOpportunityCodeFromLocal();
  };

  const isBMOUser: boolean = userPermissions?.includes("system_bmo");
  return (
    <div className="motif-no-padding">
      <MotifHeader
        className="cthome-header"
        fixed={false}
        logo={
          <a aria-label="EY Logo - Home" href="/ct/" className="cthome-logo">
            <img src={eyLogo} alt="EY logo" width="115px" height="46px" />
          </a>
        }
        rightComponents={
          <>
            <div className="motif-header-right">
              <a className="ctnav-link" href="/ct/">
                Our Products
              </a>
              <a className="ctnav-link" href="/">
                Commercial Hub
              </a>
              {isBMOUser && (
                <a className="ctnav-link" href="/ct/bmo">
                  BMO Team
                </a>
              )}
              <div>
                <MotifTooltip
                  contentClassName="tooltip-content"
                  id={"ct-tooltip-user-panel"}
                  allowClick
                  allowHover
                  hideArrow
                  trigger={
                    <MotifAvatar
                      aria-label="User Avatar"
                      size="small"
                      description="UserName name.use@ey.com"
                      src={avatar}
                      userName={name}
                    />
                  }
                >
                  <>
                    <div className="user-panel-avatar">
                      <MotifAvatar
                        aria-label="User Avatar"
                        size="small"
                        description="UserName name.use@ey.com"
                        src={avatar}
                        userName={name}
                      />
                      <div>
                        <div className="user-panel-avatar-username">{name}</div>
                        <div className="user-panel-avatar-email">{emailId}</div>
                      </div>
                    </div>
                    <div className="logout-wrapper">
                      <MotifIcon
                        iconFunction={IconoirLogOut}
                        size="24"
                        fill="#fff"
                      />

                      <div className="logout-icon">
                        <Button
                          onClickHandler={handleLogout}
                          label="Log Out"
                          variant="secondary"
                          className="logout-btn"
                        />
                      </div>
                    </div>
                  </>
                </MotifTooltip>
              </div>
            </div>
          </>
        }
      />
      <MaintenanceWindow />
    </div>
  );
};

export default CTHeader;
